import CardActionArea from './CardActionArea'

export default CardActionArea
